import React from 'react';

type OperatorButtonProps = {
  name?: string;
  logo?: string;
  onClick?: () => void;
};

const OperatorButton = ({ name, logo, onClick }: OperatorButtonProps) => {
  return (
    <button className="operator-button" onClick={onClick}>
      {logo && <img src={logo} alt={name} className="operator-logo" />}
      {!logo && (
        <strong>
          <p className="mb-0 font-size-6">{name}</p>
        </strong>
      )}
    </button>
  );
};

export default OperatorButton;
